import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import Typography from '../../../../../../components/Typography';

export interface InstructionBoxProps {
  icon: ReactNode;
  label: string;
}

const InstructionBox = ({ icon, label }: InstructionBoxProps) => {
  return (
    <Stack alignItems="center" gap={1}>
      {icon}
      <Typography variant="paragraphMedium">{label}</Typography>
    </Stack>
  );
};
export default InstructionBox;
